
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import '../Helper/links';
import { _endPoints } from "../Helper/links";
import API from "../Helper/server/API";
import { RESORT_LOGO_PATH } from '../Helper/user';
import { View_last_price, View_number_people, View_number_people_max, View_sea_distance, View_state } from "../functions/data_view";
import view_apartment_type_ar from "../functions/view_apartment_type";
import apartmentEmpty from '../public/images/apartment.png';
import empty from '../public/svg/empty.svg';
import ApartmentNewComponet from './ApartmentNewComponet';
import ApartmentUpdateComponet from './ApartmentUpdateComponet';

function Apartments() {
    const toast = useRef(null);
    // const Navigate = useNavigate();
    const [apartments, setApartments] = useState([]);
    const [apartment_edit, set_apartment_edit] = useState(null);
    const [show_new_apartment, set_show_new_apartment] = useState(false);
    const [show_update_apartment, set_show_update_apartment] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //_______________________________________________________________________________________
    //                      Get Apartments
    const imageBodyTemplate = (rowData) => {
        if (rowData?.files?.length > 0)
            return <img src={_endPoints.apartments.images + rowData?.files[0]?.path_file} alt={`image_${rowData.ID_apartment}`} width="200rem" height={"150rem"} className="shadow-4" style={{ objectFit: "cover" }}
                onError={(e) => {
                    e.target.onerror = null; // لمنع loop
                    e.target.src = apartmentEmpty; // صورة افتراضية
                }}
            />;
        else
            return <img src={apartmentEmpty} alt={`image_${rowData.ID_apartment}`} width="200rem" height={"150rem"} className="shadow-4" style={{ objectFit: "cover" }} />;

    };
    const View_Button = (item) => {
        return (
            <>
                <Button
                    type="button"
                    icon="pi pi-external-link"
                    text
                    severity="secondary"
                    className="ml-1"
                    onClick={(e) => {
                        // set_user_delete(item)
                        // set_show_delete(true)
                    }}
                />
                <Button
                    type="button"
                    icon="pi pi-pencil"
                    text
                    className="ml-1"
                    onClick={(e) => {
                        set_apartment_edit(item)
                        set_show_update_apartment(true);
                    }}
                />
                <Button
                    type="button"
                    icon="pi pi-trash"
                    text
                    severity="danger"
                    onClick={(e) => {
                        // set_user_delete(item)
                        // set_show_delete(true)
                    }}
                />
            </>
        )
    }
    const renderHeader = () => {
        return (
            <div className="w-100">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                    <div className="font-bold" style={{ fontFamily: "Cairo", fontSize: "16px" }} dir="rtl">
                        {apartments.length ? <>{apartments.length} إقـــامة</> : null}
                    </div>
                    <div style={{ fontFamily: "Cairo" }}>
                        <div className="d-flex align-items-center gap-2">
                            <Button icon="fa fa-refresh" rounded outlined onClick={GetApartments} style={{ color: "#3498db" }} />
                            <Button icon="fa fa-plus ml-2" label="إقــامة جــديده" outlined onClick={(e) => set_show_new_apartment(true)} style={{ color: "#3498db" }} />
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    //_______________________________________________________________________________________
    //                      Set Apartment

    //_______________________________________________________________________________________
    //                      Get Apartments
    const items = Array.from({ length: 20 }, (v, i) => i);
    const [LodingGetAartments, setLodingGetAartments] = useState(true);
    const GetApartments = async () => {
        setLodingGetAartments(true)
        var response = await API.post(_endPoints.apartments.get_apartments, { "state": 1 });
        if (response?.success === 1) {
            setApartments(response.data);
            setLodingGetAartments(false)
        }
        else if (response.success == 0) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response.msg
            });
        }
    }
    useEffect(() => {
        GetApartments();
    }, []);

    return (
        <div class="page-wrapper" dir="rtl" >
            <div class="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div class="page-heading">
                    <h1 class="page-title"> إدارة الشقق </h1>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="index.html"><i class="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body">
                                {
                                    LodingGetAartments ?
                                        isMobile ? (
                                            <div className="row">
                                                {Array.from({ length: 4 }).map((_, idx) => (
                                                    <div className="col-12 col-sm-6 mb-4" key={idx}>
                                                        <div className="p-3 bg-white" style={{ borderRadius: "16px", border: "1px solid rgba(0,0,0,0.08)" }}>
                                                            <Skeleton width="100%" height="150px" className="mb-3" style={{ borderRadius: "12px" }}></Skeleton>
                                                            <div className="d-flex justify-content-between mb-3">
                                                                <Skeleton width="40%" height="1.5rem"></Skeleton>
                                                                <Skeleton width="20%" height="1.5rem"></Skeleton>
                                                            </div>
                                                            <Skeleton width="60%" height="1rem" className="mb-2"></Skeleton>
                                                            <Skeleton width="80%" height="1rem" className="mb-3"></Skeleton>
                                                            <div className="d-flex justify-content-end gap-2 border-top pt-3">
                                                                <Skeleton width="40px" height="2rem" shape="circle"></Skeleton>
                                                                <Skeleton width="40px" height="2rem" shape="circle"></Skeleton>
                                                                <Skeleton width="40px" height="2rem" shape="circle"></Skeleton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <DataTable value={items} style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}>
                                                <Column field="image" header="غلاف الإقامة" style={{ textAlign: "right", maxWidth: "8rem" }} body={<Skeleton />}></Column>
                                                <Column field="type" header="نوع " sortable style={{ textAlign: "right", maxWidth: "7rem" }} body={<Skeleton />}></Column>
                                                <Column field="number" header="كود الإقامة" sortable style={{ textAlign: "right", maxWidth: "10rem" }} body={<Skeleton />}></Column>
                                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right", maxWidth: "20rem" }} body={<Skeleton />}></Column>
                                                <Column field="number_people_max" header="زيادة الأشخاص" sortable style={{ textAlign: "right", maxWidth: "7rem" }} body={<Skeleton />}></Column>
                                                <Column field="sea_distance" header="مسافة شاطئ" sortable style={{ textAlign: "right", maxWidth: "10rem" }} body={<Skeleton />}></Column>
                                                <Column field="number_people" header="الأشخاص" sortable style={{ textAlign: "right", maxWidth: "7rem" }} body={<Skeleton />}></Column>
                                                <Column field="price" header="السعر بعد تخفيض" style={{ textAlign: "right", maxWidth: "10rem" }} body={<Skeleton />}></Column>
                                                <Column field="rating_star" header="حالتــه" sortable style={{ textAlign: "right", maxWidth: "10rem" }} body={<Skeleton />}></Column>
                                                <Column field="price" header="اجراء" style={{ textAlign: "right", maxWidth: "10rem" }} body={<Skeleton />}></Column>
                                            </DataTable>
                                        )
                                        :
                                        isMobile ? (
                                            <div>
                                                <div className="mb-3 bg-white p-3 shadow-sm rounded-lg" style={{ borderRadius: "12px", border: "1px solid rgba(0,0,0,0.05)" }}>
                                                    {renderHeader()}
                                                </div>
                                                {apartments.length === 0 ? (
                                                    <center>
                                                        <img src={empty} alt="empty" width={"20%"} className="m-4"></img>
                                                        <h3>لايــوجد إقــامات</h3>
                                                    </center>
                                                ) : (
                                                    <div className="row">
                                                        {apartments.map((item) => (
                                                            <div className="col-12 col-sm-6 mb-4" key={item.ID_apartment}>
                                                                <div className="bg-white p-3" style={{ borderRadius: "16px", border: "1px solid rgba(0,0,0,0.08)", boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)" }}>
                                                                    <div className="position-relative" style={{ height: "180px", borderRadius: "12px", overflow: "hidden", marginBottom: "1rem" }}>
                                                                        {item?.files?.length > 0 ? (
                                                                            <img src={_endPoints.apartments.images + item?.files[0]?.path_file} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                onError={(e) => {
                                                                                    e.target.onerror = null;
                                                                                    e.target.src = apartmentEmpty;
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <img src={apartmentEmpty} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                                        )}
                                                                        {/* Floating Tag for Status */}
                                                                        <div style={{ position: "absolute", top: "10px", right: "10px", zIndex: 2 }}>
                                                                            {item.state ? (
                                                                                <Tag severity="success" value="فعال" style={{ fontFamily: "Cairo", fontSize: "0.8rem", padding: "4px 10px", borderRadius: "20px" }} />
                                                                            ) : (
                                                                                <Tag severity="danger" value="متوقف" style={{ fontFamily: "Cairo", fontSize: "0.8rem", padding: "4px 10px", borderRadius: "20px" }} />
                                                                            )}
                                                                        </div>
                                                                        {/* Floating Tag for Type */}
                                                                        <div style={{ position: "absolute", top: "10px", left: "10px", zIndex: 2 }}>
                                                                            <span className="badge bg-dark text-white" style={{ fontSize: "0.8rem", padding: "6px 12px", borderRadius: "20px", fontFamily: "Cairo", backgroundColor: "rgba(0,0,0,0.6)" }}>
                                                                                {view_apartment_type_ar(item)}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                                        <h4 style={{ fontFamily: "Cairo", fontSize: "1.1rem", fontWeight: "bold", margin: 0 }}>{item.name || "بدون اسم"}</h4>
                                                                        <span className="badge text-primary" style={{ border: "1px solid #3498db", fontSize: "0.8rem", padding: "4px 8px", borderRadius: "4px" }}>
                                                                            {item.number}
                                                                        </span>
                                                                    </div>

                                                                    <div className="row g-2 mb-3" style={{ fontSize: "0.9rem", color: "#666" }}>
                                                                        <div className="col-6 d-flex align-items-center">
                                                                            <i className="pi pi-map-marker text-primary ml-2" style={{ fontSize: "1rem" }}></i>
                                                                            <span>{View_sea_distance(item)}</span>
                                                                        </div>
                                                                        <div className="col-6 d-flex align-items-center">
                                                                            <i className="pi pi-users text-primary ml-2" style={{ fontSize: "1rem" }}></i>
                                                                            <span>{View_number_people(item)}</span>
                                                                        </div>
                                                                        <div className="col-12 d-flex align-items-center mt-2">
                                                                            <i className="pi pi-user-plus text-primary ml-2" style={{ fontSize: "1rem" }}></i>
                                                                            <span>الزيادة المسموحة: {View_number_people_max(item)}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between align-items-baseline mb-3 p-2" style={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
                                                                        <span style={{ fontSize: "0.85rem", color: "#777" }}>سعر الليلة:</span>
                                                                        <div>
                                                                            {item.discount > 0 && (
                                                                                <span style={{ textDecoration: "line-through", color: "#999", fontSize: "0.9rem", marginLeft: "8px" }}>
                                                                                    {item.price} د.ل
                                                                                </span>
                                                                            )}
                                                                            <span className="text-success font-bold" style={{ fontSize: "1.2rem", marginRight: "8px" }}>
                                                                                {item.price - item.discount} د.ل
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-end gap-2 pt-2 border-top">
                                                                        <Button
                                                                            type="button"
                                                                            icon="pi pi-external-link"
                                                                            text
                                                                            severity="secondary"
                                                                            onClick={(e) => {
                                                                                // set_user_delete(item)
                                                                                // set_show_delete(true)
                                                                            }}
                                                                        />
                                                                        <Button
                                                                            type="button"
                                                                            icon="pi pi-pencil"
                                                                            text
                                                                            onClick={(e) => {
                                                                                set_apartment_edit(item)
                                                                                set_show_update_apartment(true);
                                                                            }}
                                                                        />
                                                                        <Button
                                                                            type="button"
                                                                            icon="pi pi-trash"
                                                                            text
                                                                            severity="danger"
                                                                            onClick={(e) => {
                                                                                // set_user_delete(item)
                                                                                // set_show_delete(true)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <DataTable value={apartments} loading={LodingGetAartments} header={renderHeader()}
                                                metaKeySelection={false} dragSelection
                                                stripedRows removableSort
                                                paginator rows={5} rowsPerPageOptions={[5, 10, 20, 30, 50]}
                                                scrollable scrollHeight="900px"
                                                sortMode="multiple"
                                                className="custom-scrollbar"
                                                size="normal" selectionMode="multiple"
                                                emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد إقــامات</h3></center>}
                                                style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}
                                            >
                                                <Column field="image" header="غلاف الإقامة" body={imageBodyTemplate} style={{ textAlign: "right", maxWidth: "15rem" }}></Column>
                                                <Column field="type" header="نوع " body={view_apartment_type_ar} sortable style={{ textAlign: "right", maxWidth: "7rem" }}></Column>
                                                <Column field="number" header="كود الإقامة" sortable style={{ textAlign: "right", maxWidth: "10rem" }}></Column>
                                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right", maxWidth: "20rem" }}></Column>
                                                <Column field="sea_distance" header="مسافة شاطئ" body={View_sea_distance} sortable style={{ textAlign: "right", maxWidth: "10rem" }}></Column>
                                                <Column field="number_people" header="الأشخاص" body={View_number_people} sortable style={{ textAlign: "right", maxWidth: "7rem" }}></Column>
                                                <Column field="number_people_max" header="زيادة الأشخاص" body={View_number_people_max} sortable style={{ textAlign: "right", maxWidth: "7rem" }}></Column>
                                                <Column field="price" header="السعر بعد تخفيض" body={View_last_price} style={{ textAlign: "right", maxWidth: "10rem" }}></Column>
                                                <Column field="rating_star" header="حالتــه" body={View_state} sortable style={{ textAlign: "right", maxWidth: "10rem" }}></Column>

                                                {/* <Column field="price" header="السعر" body={View_price} sortable style={{textAlign:"right"}}></Column>
                                    <Column field="discount" header="التخغيض" body={View_discount} sortable style={{textAlign:"right"}}></Column> */}
                                                <Column field="price" header="اجراء" body={View_Button} style={{ textAlign: "right", maxWidth: "10rem" }}></Column>

                                            </DataTable>
                                        )
                                }


                                <Dialog dir="rtl" header={
                                    <>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <center> <img src={_endPoints.resorts.images + RESORT_LOGO_PATH} height="120px" width="auto" alt='logo' /></center>
                                            </div>
                                            <div className='col-md-12'>
                                                <center>   <h3> تعـــديل إقــامة  <i className='fa fa-home '></i> </h3></center>
                                            </div>
                                        </div>
                                        <hr></hr>
                                    </>
                                }
                                    visible={show_update_apartment} maximizable
                                    style={{ width: '100%', height: '100%', fontFamily: "Cairo" }}
                                    onHide={() => set_show_update_apartment(false)} maximized={true}>
                                    <ApartmentUpdateComponet ID_apartment={apartment_edit?.ID_apartment} set_show_update_apartment={set_show_update_apartment} GetApartments={GetApartments} toast={toast}></ApartmentUpdateComponet>
                                </Dialog>

                                <Dialog dir="rtl" header={
                                    <>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <center> <img src={_endPoints.resorts.images + RESORT_LOGO_PATH} height="120px" width="auto" alt='logo' /></center>
                                            </div>
                                            <div className='col-md-12'>
                                                <center>   <h3> إضــافة إقــامة جــــديده  <i className='fa fa-home '></i> </h3></center>
                                            </div>
                                        </div>
                                        <hr></hr>
                                    </>
                                }
                                    visible={show_new_apartment} maximizable
                                    style={{ width: '100%', height: '100%', fontFamily: "Cairo" }}
                                    onHide={() => set_show_new_apartment(false)} maximized={true}>
                                    <ApartmentNewComponet set_show_new_apartment={set_show_new_apartment} GetApartments={GetApartments} toast={toast}></ApartmentNewComponet>
                                </Dialog>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Apartments


